import { useEffect, useRef, useState } from "react";

import { SKELETON_DELAY_MS, SKELETON_MINIMUM_MS } from "./accessoryFilters";

const useSkeletonGate = (
  active,
  { delay = SKELETON_DELAY_MS, minimum = SKELETON_MINIMUM_MS } = {}
) => {
  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef(0);

  useEffect(() => {
    if (active === visible) return undefined;

    if (active) {
      const timer = setTimeout(() => {
        shownAtRef.current = Date.now();
        setVisible(true);
      }, delay);

      return () => clearTimeout(timer);
    }

    const remaining = Math.max(0, minimum - (Date.now() - shownAtRef.current));
    const timer = setTimeout(() => setVisible(false), remaining);

    return () => clearTimeout(timer);
  }, [active, visible, delay, minimum]);

  return visible;
};

export default useSkeletonGate;
